import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { ValidacaoDadoForm } from "features/projetos/pages/ProjetoEditPage/tabs/ValidacoesTab/ValidacaoDado";

async function createValidacaoDado(data: ValidacaoDadoForm): Promise<IResponse<ValidationResult>> {
    return await axios.put(`/Validacao/Dado/${data.projetoId}`, data);
}

export default createValidacaoDado;